module.exports = __webpack_public_path__ + "img/icon-album.64736152.svg";